export interface IPresign {
  uploadUrl: string;
  fileUrl: string;
  key: string;
}

export class Presign {

  uploadUrl: string;
  fileUrl: string;
  key: string;

  constructor(data: IPresign) {
    this.uploadUrl = data.uploadUrl;
    this.fileUrl = data.fileUrl;
    this.key = data.key;
  }

}
